import { render, staticRenderFns } from "./QualityManagementLayout.vue?vue&type=template&id=f38dba06&scoped=true&"
import script from "./QualityManagementLayout.vue?vue&type=script&lang=js&"
export * from "./QualityManagementLayout.vue?vue&type=script&lang=js&"
import style0 from "./QualityManagementLayout.vue?vue&type=style&index=0&id=f38dba06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38dba06",
  null
  
)

export default component.exports